export const PRODUCTION_PROPERTY_FOLDING_COUNT_NAME = 'ilosc_falcow'
export const PRODUCTION_PROPERTY_PAPER_TYPE_NAME = 'rodzaj_papieru'
export const PRODUCTION_PROPERTY_FOLDING_TYPE_ID = 83
export const PRODUCTION_PROPERTY_FOLDING_TYPE_NAME = 'rodzaj_skladania'
